<div class="page-wrapper section-hr-direct">
    <app-left-menu [showMenu]="false"></app-left-menu>

    <div id="main-container">

        <app-header [showHistoryButton]="true" [title]="title"></app-header>
        <div style="height: 40px;display: block;">&nbsp;</div>
        <div class="page-content settings">
            <div class="page-content">
                <div class="content">
                    <a [routerLink]="['mailingaddress']"
                        class="panel-link forward">{{'Common.MailingAddress'|translate}}</a>
                    <a [routerLink]="['billingaddress']"
                        class="panel-link forward">{{'Common.BillingAddress'|translate}}</a>
                    <a [routerLink]="['providersites']"
                        class="panel-link forward">{{'Common.ProviderSites'|translate}}</a>
                </div>

            </div>
        </div>
    </div>